module.exports = __webpack_public_path__ + "static/img/noorder.8538222.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/noorder.png
// module id = ZBA5
// module chunks = 1